import React from "react"
import "reset-css"
import _ from 'lodash'
import {Layout} from "../components/layout"
import {SEO} from "../components/seo"
import { Link } from "gatsby";
import Icon from '../images/creativedistrict-logo.svg'

const IndexPage = ({ pageContext: { toursDataz } }) => {
  return (
  <Layout>
    <SEO title="Design District JLM" description="Find your next design driven adventure in Jerusalem." />

    <div className="page index">
      <Icon className="logo" />
      <section>
        Mapping design locations around the city
      </section>
      <section>
        <button>Take a tour with us</button>
        <p>
          Or
        </p>
        <button>Explore design locations by yourself</button>
      </section>
        {/* <section>Design studios</section>
      <section>Restaurants and Bars</section>
      <section>Sightseeing</section>
      <section>Graffiti</section>
      <section>Fashion</section> */}
    </div>
  </Layout>
)}

export default IndexPage
